import { createSlice } from "@reduxjs/toolkit";
import {
  registerStudent,
  loginStudent,
  refreshTokenStudent,
  logoutStudent,
  getStudentProfile,
  loginStudentWithGoogle,
  verifyStudentEmailOperation,
} from "./operation.js";

const initialState = {
  studentToken: null,
  studentRefreshToken: null,
  studentLoading: false,
  studentError: null,
  studentIsLoggedIn: false,
  studentIsRefreshing: false,
  studentIsRefreshingSession: true,
  studentData: null, // 👈 Храним данные профиля
};

const authStudentSlice = createSlice({
  name: "authStudent",
  initialState,

  reducers: {
    setStudentRefreshComplete(state) {
      state.studentIsRefreshing = false;
      state.studentIsRefreshingSession = false;
    },
    setStudentToken: (state, action) => {
      state.studentToken = action.payload.studentToken || action.payload;
      state.studentRefreshToken = action.payload.refreshToken || null;
      state.studentIsLoggedIn = true;
    },

    setStudentData(state, action) {
      state.studentData = action.payload; // 👈 Сохраняем профиль
    },
  },
  extraReducers: (builder) => {
    builder
      // Register
      .addCase(registerStudent.pending, (state) => {
        state.studentLoading = true;
        state.studentError = null;
        state.studentIsLoggedIn = false;
      })
      .addCase(registerStudent.fulfilled, (state) => {
        state.studentLoading = false;
        state.studentToken = null;
        state.studentRefreshToken = null;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
        // state.studentToken = action.payload.studentToken;
        // state.studentRefreshToken = action.payload.refreshToken;
        // state.studentIsLoggedIn = true;
      })
      .addCase(registerStudent.rejected, (state, action) => {
        state.studentLoading = false;
        state.studentError = action.payload;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshingSession = false;
      })

      // Login
      .addCase(loginStudent.pending, (state) => {
        state.studentLoading = true;
        state.studentError = null;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = true;
        state.studentIsRefreshingSession = true;
      })
      .addCase(loginStudent.fulfilled, (state, action) => {
        state.studentLoading = false;
        state.studentToken = action.payload.studentToken;
        state.studentRefreshToken = action.payload.refreshToken;
        state.studentIsLoggedIn = true;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
        state.studentError = null;
      })
      .addCase(loginStudent.rejected, (state, action) => {
        state.studentLoading = false;
        state.studentError = action.payload;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
      })

      // Refresh
      .addCase(refreshTokenStudent.pending, (state) => {
        state.studentIsRefreshing = true;
        state.studentIsRefreshingSession = true;
      })
      .addCase(refreshTokenStudent.fulfilled, (state, action) => {
        state.studentToken = action.payload.studentToken;
        state.studentIsLoggedIn = true;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
        state.studentError = null;
      })
      .addCase(refreshTokenStudent.rejected, (state, action) => {
        state.studentError = action.payload;
        state.studentToken = null;
        state.studentRefreshToken = null;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
      })

      // Logout
      .addCase(logoutStudent.fulfilled, (state) => {
        state.studentToken = null;
        state.studentRefreshToken = null;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
        state.studentError = null;
        state.studentData = null;
      })
      .addCase(logoutStudent.rejected, (state, action) => {
        state.studentToken = null;
        state.studentRefreshToken = null;
        state.studentIsLoggedIn = false;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
        state.studentLoading = false;
        state.studentError = action.payload;
      })
      .addCase(getStudentProfile.fulfilled, (state, action) => {
        state.studentData = action.payload;
      })
      .addCase(loginStudentWithGoogle.fulfilled, (state, action) => {
        state.studentLoading = false;
        state.studentToken = action.payload.studentToken;
        state.studentRefreshToken = action.payload.refreshToken;
        state.studentIsLoggedIn = true;
        state.studentIsRefreshing = false;
        state.studentIsRefreshingSession = false;
      })
      .addCase(loginStudentWithGoogle.rejected, (state, action) => {
        state.studentError = action.payload;
        state.studentIsLoggedIn = false;
      })
      .addCase(verifyStudentEmailOperation.pending, (state) => {
        state.studentLoading = true;
        state.studentError = null;
      })
      .addCase(verifyStudentEmailOperation.fulfilled, (state, action) => {
        state.studentLoading = false;
        state.studentToken = action.payload;
        state.studentIsLoggedIn = true;
      })
      .addCase(verifyStudentEmailOperation.rejected, (state, action) => {
        state.studentLoading = false;
        state.studentError = action.payload;
      });
  },
});

export const { setStudentRefreshComplete, setStudentData, setStudentToken } =
  authStudentSlice.actions;
export default authStudentSlice.reducer;
